import React from 'react'

function ProductTag({tagName}) {
    
  return (
    <li>{tagName}</li>
  )
}

export default ProductTag